import {Drawer} from 'antd';
import {StyledDrawer} from './style';

export default StyledDrawer(Drawer);
